export default {
  RESEARCH: (state, payload) => {
    state.research = [];
    state.research = payload.payload;
  },
  SELECT: (state, payload) => {
    state[payload.key] = payload.value;
  },
  TAG_FILTER: (state, payload) => {
    if(payload.value.type === 'uncheckall') {
      state['filter_tag'].forEach((tag, index) => {
        if(tag.reference === payload.value.reference) {
          state['filter_tag'].splice(index, 1, {});
        }
      });
    } else if(payload.value.type === 'uncheck') {
      state['filter_tag'].map((tag, index) => {
        if(tag.key === payload.value.option) {
          state['filter_tag'].splice(index, 1);
        }
      })
    } else {
      state['filter_tag'].push({
        key: payload.value.option, 
        value: payload.value.value, 
        index: payload.value.index,
        custom_value: payload.value.custom_value,
        reference: payload.value.reference
      });
    }
  },
  REMOVE_TAG_FILTER: (state, payload) => {
    state['filter_tag'].map((tag, index) => {
      if(tag.key === payload.option) {
        state['filter_tag'].splice(index, 1);
      }
    });
    state.current_filter_tag_remove = payload;
  },
  RESET_STATE: (state, payload) => {
    Object.keys(state).map( (key) => {
      switch(typeof state[key]) {
        case 'string':
          state[key] = '';
          break;
        case 'boolean':
          state[key] = false;
          break;
      }
    })
  },
  RESET_FOR_COLLECTION: (state, payload) => {
    state.fmotc_typ = '';
    state.fmotc_mat = '';
    state.ftyp_offre = '';
    state.fmotc_cae = '';
    state.fmotc_caf = '';
    state.frech_lib = '';
  },
  SET: (state, payload) => {
    if(Array.isArray(payload)) {
      payload.map(obj => {
        state[obj.key] = obj.value;
      })
    } else {
      state[payload.key] = payload.value;
    }
  },
};